import { Grid } from '@material-ui/core';
import {
  createAutocompleteAddressField,
  createNumberFormatField,
  createTextField,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { TitleCompanyBankInformationStore } from '../../../stores/documentForms/titleCompanyBankInformation/titleCompanyBankInformationStore';

interface Props {
  titleCompanyBankInformationStore: TitleCompanyBankInformationStore;
}

export const TitleCompanyBankInformationForm = observer((props: Props) => {
  const { titleCompanyBankInformationStore } = props;
  const store = titleCompanyBankInformationStore;

  const handleAddressChange = event => {
    const { value, fullInfo } = event?.target || {};
    const { address_components, geometry } = fullInfo || {};
    titleCompanyBankInformationStore.handleAddressChange(
      value,
      address_components,
      geometry
    );
  };

  const disabled = false;

  return (
    <Grid container spacing={2}>
      {/* Title Company */}
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'entityName',
          fieldName: 'entityName',
          label: 'Title Company Name',
          disabled,
        })}
      </Grid>
      <Grid item xs={12}>
        {createAutocompleteAddressField({
          store,
          testId: 'address',
          fieldName: 'address',
          label: 'Title Company Address',
          onChange: handleAddressChange,
          disabled,
        })}
      </Grid>

      {/* Contact Information */}
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'fullName',
          fieldName: 'fullName',
          label: 'Authorized Contact Name',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'authorizedContactTitle',
          fieldName: 'authorizedContactTitle',
          label: 'Authorized Contact Title',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'phone',
          fieldName: 'phone',
          label: 'Direct Phone',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'email',
          fieldName: 'email',
          label: 'Email Address',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'titleLicense',
          fieldName: 'titleLicense',
          label: 'Title License / Escrow Number',
          disabled,
        })}
      </Grid>

      {/* Bank Information */}
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'bankName',
          fieldName: 'bankName',
          label: 'Bank Name',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createNumberFormatField({
          store,
          testId: 'routingNumber',
          fieldName: 'routingNumber',
          label: 'Routing Number',
          format: '#########',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'accountName',
          fieldName: 'accountName',
          label: 'Account Name',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createNumberFormatField({
          store,
          testId: 'accountNumber',
          fieldName: 'accountNumber',
          label: 'Account Number',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'referenceId',
          fieldName: 'referenceId',
          label: 'Reference Id',
          disabled,
        })}
      </Grid>

      {/* International Wires */}
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'swiftCode',
          fieldName: 'swiftCode',
          label: 'SWIFT / BIC Code',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'intermediaryBankName',
          fieldName: 'intermediaryBankName',
          label: 'Intermediary Bank Name',
          disabled,
        })}
      </Grid>
      <Grid item xs={6}>
        {createTextField({
          store,
          testId: 'intermediaryRoutingNumber',
          fieldName: 'intermediaryRoutingNumber',
          label: 'Intermediary Routing Number',
          disabled,
        })}
      </Grid>

      {/* Geraci Law Firm */}
      {store.isGeraci && (
        <>
          <Grid item xs={6}>
            {createNumberFormatField({
              store,
              testId: 'ffcBankName',
              fieldName: 'ffcBankName',
              label: 'FFC Bank Name',
              disabled,
            })}
          </Grid>
          <Grid item xs={6}>
            {createNumberFormatField({
              store,
              testId: 'ffcRoutingNumber',
              fieldName: 'ffcRoutingNumber',
              label: 'FFC Routing Number',
              disabled,
            })}
          </Grid>
          <Grid item xs={6}>
            {createNumberFormatField({
              store,
              testId: 'ffcAccountName',
              fieldName: 'ffcAccountName',
              label: 'FFC Account Name',
              disabled,
            })}
          </Grid>
          <Grid item xs={6}>
            {createNumberFormatField({
              store,
              testId: 'ffcAccountNumber',
              fieldName: 'ffcAccountNumber',
              label: 'FFC Account Number',
              disabled,
            })}
          </Grid>
        </>
      )}
    </Grid>
  );
});
